import { render, staticRenderFns } from "./NormalTabs.vue?vue&type=template&id=8e697b92"
import script from "./NormalTabs.vue?vue&type=script&lang=js"
export * from "./NormalTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports